'use client';

import { Stack } from '@chakra-ui/react';
import ErrorBoundary from '@/components/ErrorBoundary';
import { sendAppierEvent } from '@/utils/appier';
import { usePathname } from 'next/navigation';
import useWebView from '@/hooks/useWebView';
import Messenger from '@/utils/Messenger';
import Message from '@/utils/Message';

interface CustomerServiceButtonProps {
  customerName?: string;
  customerEmail?: string;
  phone?: string;
  userId?: string;
}

export default function CustomerServiceButton({
  customerName,
  customerEmail,
  phone,
  userId,
}: CustomerServiceButtonProps) {
  // 即時派車下訂畫面不顯示客服按鈕
  const pathname = usePathname();
  const { isSupport } = useWebView();
  const hideWidget =
    pathname.includes('/instant-go/customer') || pathname.includes('/instant-go/driving');

  if (hideWidget) {
    return <></>;
  }

  return (
    <ErrorBoundary>
      <Stack
        position="fixed"
        zIndex="2147483639"
        bottom="16px"
        right="21px"
        w="60px"
        h="60px"
        alignItems="center"
        justifyContent="center"
        bg="#F2F2F2"
        borderRadius="30px"
        boxShadow="rgba(0, 0, 0, 0.125) 0px 0.362176px 0.941657px -1px,rgba(0, 0, 0, 0.18) 0px 3px 7.8px -2px"
        _hover={{
          '&>*>svg>path:nth-child(2)': { opacity: 0 },
          '&>*': { transform: 'scale(1.05)' },
        }}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          // Appier Event Click_helper 聯繫客服
          sendAppierEvent('Click_helper', {
            user_id: userId || '未登入',
            phoneNo: phone || '未登入',
            user_name: customerName || '未提供',
            page_name: window?.top?.location?.pathname,
          });

          const url =
            'https://lin.ee/aYFZhRB?utm_source=app&utm_medium=button&utm_campaign=20250924-instantgrab-linecs';
          if (isSupport) {
            Messenger.sendMessage(new Message('openBrowser', url));
          } else {
            window.open(url, '_blank', 'noopener,noreferrer');
          }
        }}
      >
        <Stack
          position="relative"
          w="32px"
          h="32px"
        >
          <svg
            color="inherit"
            viewBox="0 0 32 32"
            fill="currentColor"
          >
            <path
              fill="#111111"
              d="M12.63,26.46H8.83a6.61,6.61,0,0,1-6.65-6.07,89.05,89.05,0,0,1,0-11.2A6.5,6.5,0,0,1,8.23,3.25a121.62,121.62,0,0,1,15.51,0A6.51,6.51,0,0,1,29.8,9.19a77.53,77.53,0,0,1,0,11.2,6.61,6.61,0,0,1-6.66,6.07H19.48L12.63,31V26.46"
            />
            <path
              fill="#F2F2F2"
              d="M19.57,21.68h3.67a2.08,2.08,0,0,0,2.11-1.81,89.86,89.86,0,0,0,0-10.38,1.9,1.9,0,0,0-1.84-1.74,113.15,113.15,0,0,0-15,0A1.9,1.9,0,0,0,6.71,9.49a74.92,74.92,0,0,0-.06,10.38,2,2,0,0,0,2.1,1.81h3.81V26.5Z"
            />
          </svg>
          <Stack
            position="absolute"
            top="0px"
            left="0px"
            w="32px"
            h="32px"
            alignItems="center"
            justifyContent="center"
          >
            <svg
              viewBox="0 0 60 40"
              width="18px"
              fill="#F2F2F2"
            >
              <circle
                r="6"
                cx="9"
                cy="20"
                fill="#F2F2F2"
              />
              <circle
                r="6"
                cx="30"
                cy="20"
                fill="#F2F2F2"
              />
              <circle
                r="6"
                cx="51"
                cy="20"
                fill="#F2F2F2"
              />
            </svg>
          </Stack>
        </Stack>
      </Stack>
    </ErrorBoundary>
  );
}
